import React, { useState, useEffect } from 'react';
import { Container, Modal, Image } from 'react-bootstrap';
import ambassadeurs from "./files/ambassadeurs.json"
import './Ambassaseurs.css';

const App = () => {
  const [articles, setArticles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [articleContent, setArticleContent] = useState("");

    // Mélanger les articles au chargement
  useEffect(() => {
    const shuffled = [...ambassadeurs].sort(() => Math.random() - 0.5);
    setArticles(shuffled);
  }, []);



  
  const handleImageClick = (image) => {
    setSelectedArticle(image);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedArticle(null);
    setArticleContent("");
  };

  useEffect(() => {
    if (selectedArticle) {
      fetch('/documents/ambassadeurs/'+selectedArticle.contentFile)
        .then((res) => res.text())
        .then((text) => setArticleContent(text))
        .catch(() => setArticleContent("Erreur de chargement du contenu."));
    }
  }, [selectedArticle]);

  const highlightText = (text) => {
    return text.split(/(\s+)/).map((word, index) => {
      if (/^#[\wÀ-ÿ-]+$/.test(word)) {
        return <span key={index} className="hashtag">{word}</span>;
      }
      if (/^\d+$/.test(word) || /^[A-ZÉÈÊÀÂÎÔÛÇ0-9\.,]{2,}$/.test(word)) {
        return <strong key={index}>{word}</strong>;
      }
      return word;
    });
  };

  const formatContent = (content) => {
    return content.split("\n").filter(Boolean).map((line, index) => (
      <span key={index}>
        {highlightText(line.trim())}
        <br />
      </span>
    ));
  };

  const renderTitle = (article) => (
    <>
      <span>{article.title}</span>
      {article.link && (
        <span>
          &nbsp;– <a target="_blank" rel="noopener noreferrer" href={article.link}>En savoir plus</a>
        </span>
      )}
    </>
  );

  return (
    <div id="App" style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/filigrane.svg)`
        }}>
      <Container>
        <div className="Ambassadeurs">
          {articles.map((img, index) => (
            <div key={index} className={`article-image-title ${img.theme}`}>
              <Image
                className={`article-image-thumbnail`}
                src={`/documents/ambassadeurs/${img.src}`}
                thumbnail
                onClick={() => handleImageClick(img)}
                style={{ cursor: 'pointer' }}
              />
              <span className="article-image-title-texte">{img.title}</span>
            </div>
          ))}
        </div>

        <Modal show={showModal} onHide={handleCloseModal} size="xl">
          {selectedArticle && (
            <>
              <Modal.Header closeButton>
                <Modal.Title className='title-flex'>{renderTitle(selectedArticle)}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="Ambassadeurs-modal">
                  <img
                    src={`/documents/ambassadeurs/${selectedArticle.src}`}
                    alt={selectedArticle.title}
                    className="article-image"
                  />
                  <p className="article-content">{formatContent(articleContent)}</p>
                </div>
              </Modal.Body>
            </>
          )}
        </Modal>
      </Container>
    </div>
  );
};

export default App;
